































































































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCollectorModel from "./createcollectormodel.vue";
import EditCollectorModel from "./editcollectormodel.vue";
import CopyCollectorModel from "./copycollectormodel.vue";
import "@/assets/css/table.css";
import checkAuth from "@/lib/Common/checkauth";

class PageCollectorModelRequest extends PageRequest {
  keyword: string;
  areaId: number;
  collectorType: number = 0;
  isp: number = 0;
  isEnable: number = 9; //nullable
}

@Component({
  components: { CreateCollectorModel, EditCollectorModel, CopyCollectorModel },
})
export default class cellectormodel extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageCollectorModelRequest = new PageCollectorModelRequest();
  creationTime: Date[] = [];
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  splitnum: number = 0.15;

  isappId: boolean = false; //appid
  isappSecret: boolean = false; //appsecret
  istenantId: boolean = false; //租户id
  isproductId: boolean = false; //产品id
  ismasterId: boolean = false; //masterId
  ismanufacturerId: boolean = false; //厂商Id
  ismanufacturerName: boolean = false; //厂商名称
  isdeviceModel: boolean = false; //设备类型
  isobjId: boolean = false; //对象id
  isobjInstid: boolean = false; //实例id
  isresId: boolean = false; //资源Id
  isSort: boolean = false; //排序
  sendPartion:boolean = false;
  showcolumn: boolean = false; //显示列选择窗口
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.collectormodel.list;
  }
  get loading() {
    return this.$store.state.collectormodel.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnable = val;
    this.$store.commit("collectormodel/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("collectormodel/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("collectormodel/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("collectormodel/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "collectormodel/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.collectormodel.pageSize;
  }
  get totalCount() {
    return this.$store.state.collectormodel.totalCount;
  }
  get currentPage() {
    return this.$store.state.collectormodel.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 160,
      fixed: "left",
    },
    {
      title: this.L("Device") + this.L("Category"),
      key: "deviceTypeId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("ISP"),
      key: "isp",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appId },
            },
            params.row.appId
          ),
        ]);
      },
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.productId },
            },
            params.row.productId
          ),
        ]);
      },
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("SendPartion"),
      key: "sendPartion",
      width: 130,
    },
    {
      title: this.L("RateNum"),
      key: "rateNum",
      width: 130,
    },
    {
      title: "Id",
      key: "id",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('collectorModelDel');
        let edit = this.checkButtonAuth('collectorModelEdit');
        let copy = this.checkButtonAuth('collectorModelCopy');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("collectormodel/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("collectormodel/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "collectormodel/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.computeCol();
    this.getpage();
    this.pagerequest.isEnable = 9;
    this.getAreaTree();
    this.getItemDetail();
  }
  changeStates() {
    this.computeCol();
  }
  computeCol() {
    let columns = this.columns;
    if (!this.isappId) {
      columns = columns.filter((col) => col.key !== "appId");
    }
    if (!this.isappSecret) {
      columns = columns.filter((col) => col.key !== "appSecret");
    }
    if (!this.istenantId) {
      columns = columns.filter((col) => col.key !== "aepTenantId");
    }
    if (!this.isproductId) {
      columns = columns.filter((col) => col.key !== "productId");
    }
    if (!this.ismasterId) {
      columns = columns.filter((col) => col.key !== "masterId");
    }
    if (!this.ismanufacturerId) {
      columns = columns.filter((col) => col.key !== "manufacturerId");
    }
    if (!this.ismanufacturerName) {
      columns = columns.filter((col) => col.key !== "manufacturerName");
    }
    if (!this.isdeviceModel) {
      columns = columns.filter((col) => col.key !== "deviceModel");
    }
    if (!this.isobjId) {
      columns = columns.filter((col) => col.key !== "obj_Id");
    }
    if (!this.isobjInstid) {
      columns = columns.filter((col) => col.key !== "obj_Inst_id");
    }
    if (!this.isresId) {
      columns = columns.filter((col) => col.key !== "res_Id");
    }
    if (!this.isSort) {
      columns = columns.filter((col) => col.key !== "sortCode");
    }
    this.columnlist = columns;
  }
  data() {
    return {
      collectorTypedetail: [],
      ispdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 4;
      });
      info.forEach((ele) => {
        this.$data.collectorTypedetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let isp = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      isp.forEach((ele) => {
        this.$data.ispdetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
}
